// extracted by mini-css-extract-plugin
export default {"element":"style_element__H-W80","frame":"style_frame__Xw9Ot"};